export default {"src":"/_next/static/media/analysis.79c3ee1d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};